import React from 'react';
import Button from './index.js';

const AccentButton = props => (
    <Button buttonType="button-accent" {...props} />
);
export default AccentButton;
